















import linkDirective from '@/shared/directives/link-directive';
import ICategory from '../models/category';
import {defineComponent, PropType} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: "Category",
  directives: {
    linkDirective
  },
  props: {
    category: {type: Object as PropType<ICategory>, required: true}
  },
  setup: () => {
    const {selectCategoryUrl} = useGetters(['selectCategoryUrl'])

    return {
      selectCategoryUrl
    }
  }
})
